import { useEffect } from "react";
import {
  useFetchDevices,
  useFetchNotificationCampaigns,
  useFetchNotifications,
  useFetchUsers
} from "../../../apiHooks";

export const useFetchData = () => {
  const {
    fetchCallback: fetchNotifications,
    data: { notifications, systemNotifications },
    loading: notificationsLoading,
    refresh: notificationsRefresh
  } = useFetchNotifications();

  const {
    fetchCallback: fetchNotificationCampaigns,
    data: notificationCampaigns,
    loading: notificationCampaignsLoading,
    refresh: notificationCampaignsRefresh
  } = useFetchNotificationCampaigns();

  const {
    fetchCallback: fetchDevices,
    loading: devicesLoading,
    refresh: devicesRefresh
  } = useFetchDevices();

  const {
    fetchCallback: fetchUsers,
    loading: usersLoading,
    refresh: usersRefresh
  } = useFetchUsers();

  useEffect(() => {
    fetchNotifications(false);
    fetchNotificationCampaigns(false);
    fetchDevices(false);
    fetchUsers(false);
  }, []);

  useEffect(() => {
    if (notificationsRefresh) {
      fetchNotifications(true);
    }
  }, [notificationsRefresh]);

  useEffect(() => {
    if (notificationCampaignsRefresh) {
      fetchNotificationCampaigns(true);
    }
  }, [notificationCampaignsRefresh]);

  useEffect(() => {
    if (devicesRefresh) {
      fetchDevices(true);
    }
  }, [devicesRefresh]);

  useEffect(() => {
    if (usersRefresh) {
      fetchUsers(true);
    }
  }, [usersRefresh]);

  return {
    notifications,
    systemNotifications,
    notificationCampaigns,
    notificationsLoading,
    notificationCampaignsLoading,
    devicesLoading,
    usersLoading
  };
};
